import { Injectable } from '@angular/core';
import { Observable, Subject, retry, catchError } from 'rxjs';
import { SubscriptionModel } from 'src/app/core/interfaces/subscription.interface';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { handleError } from '../utils/generic-utils';

export interface ChannelsResponse {
  id?: string;
  name?: string;
  logo_id?: string;
  stream_source: string;
  provider?: string;
  is_external?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ChannelsService {
  endpoint: string = environment.performTVApi.url;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    responseType: 'json'
  });
  retry = 0;

  constructor(private http: HttpClient) {}

  private subjectChannelSubs = new Subject<SubscriptionModel>();

  sendChannelSubs(data: SubscriptionModel) {
    this.subjectChannelSubs.next(data);
  }

  getChannelsSubs() {
    return this.subjectChannelSubs.asObservable();
  }

  getChannels(): Observable<ChannelsResponse[]> {
    let api = `${this.endpoint}/stations`;
    return this.http
      .get<ChannelsResponse[]>(api, {
        headers: this.headers,
        responseType: 'json'
      })
      .pipe(retry(this.retry), catchError(handleError));
  }

  createChannel(payload: ChannelsResponse): Observable<{}> {
    let api = `${this.endpoint}/stations`;
    return this.http
      .post(api, payload, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(handleError));
  }

  editChannel(channelId: string, payload: ChannelsResponse): Observable<any> {
    let api = `${this.endpoint}/station/${channelId}`;
    return this.http
      .put(api, payload, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(handleError));
  }

  deleteChannel(channelId: string): Observable<any> {
    let api = `${this.endpoint}/station/${channelId}`;
    return this.http
      .delete(api, { headers: this.headers, responseType: 'json' })
      .pipe(retry(this.retry), catchError(handleError));
  }
}
